<template>
  <div class="search-attribute-filter search-attribute-filter__root">
    <pui-attribute-panel
      v-if="simpleAttribute"
      :value="value"
      :attribute="attributeFilter.attribute"
      :loadOptionsFunction="loadOptionsFunction"
      @valueChanged="onChange"
      :labelFunction="labelFunction"
      :showLabel="showLabel"
      :lazyOptions="lazyOptions"
      class="file-search-form__attribute-panel"
    >
    </pui-attribute-panel>

    <pui-flex v-else-if="isDateRange || isNumericRange" class="search-attribute-filter__form-group">
      <pui-flex flex="1" class="search-attribute-filter__form-col">
        <pui-attribute-panel
          :value="rangeStartValue"
          :attribute="attributeFilter.attribute"
          :loadOptionsFunction="loadOptionsFunction"
          @valueChanged="onRangeChange($event, rangeEndValue, 'start')"
          :labelFunction="() => rangeStartLabel"
          :showLabel="showLabel"
          :lazyOptions="lazyOptions"
          class="col-attribute-panel"
        >
        </pui-attribute-panel>
      </pui-flex>
      <pui-flex flex="1" class="search-attribute-filter__form-col">
        <pui-attribute-panel
          :value="rangeEndValue"
          :attribute="attributeFilter.attribute"
          :loadOptionsFunction="loadOptionsFunction"
          @valueChanged="onRangeChange(rangeStartValue, $event, 'end')"
          :labelFunction="() => rangeEndLabel"
          :showLabel="showLabel"
          :lazyOptions="lazyOptions"
          class="col-attribute-panel"
        >
        </pui-attribute-panel>
      </pui-flex>
    </pui-flex>
  </div>
</template>

<script>
import Vue from 'vue';

import { AttributeTypes } from '../../../../common/constants';
import { getAttributeLinkOptions } from '../../../helpers/formAttributes';

export default {
  props: {
    attributeFilter: {
      type: Object,
      required: true,
    },
    value: {
      type: null,
    },
    /**
     * Force associated label to show/hide.
     * Set to 'null' to use attribute's option
     */
    displayLabel: {
      type: null,
      default: null,
    },
    lazyOptions: {
      type: Boolean,
      default: false,
    },
    loadOptionsFunction: {
      type: Function,
      required: true,
    },
  },
  computed: {
    /**
     * @returns {boolean} if the attribute filter is a date range
     */
    isDateRange() {
      return (
        this.attributeFilter.options.range &&
        this.attributeFilter.attribute.type === AttributeTypes.DATE
      );
    },
    /**
     * @returns {boolean} if the attribute filter is a numeric range
     */
    isNumericRange() {
      return (
        this.attributeFilter.options.range &&
        this.attributeFilter.attribute.type === AttributeTypes.NUMERIC
      );
    },
    /**
     * @returns {boolean} if the attribute filter is a simple attribute
     */
    simpleAttribute() {
      return !this.attributeFilter.options.range;
    },
    /**
     * @returns {boolean} if the label should be displayed
     */
    showLabel() {
      return this.displayLabel !== null
        ? this.displayLabel !== false // Forced prop value
        : !this.attributeFilter.attribute.options ||
            this.attributeFilter.attribute.options.showLabel !== false;
    },
    /**
     * @returns {string} the label for the range start
     */
    rangeStartLabel() {
      if (!this.showLabel) {
        return '';
      }
      if (this.attributeFilter.options._startLabelKey) {
        return this.$t(this.attributeFilter.options._startLabelKey);
      }
      return this.piivoTranslateLabel(this.attributeFilter.options.startLabel);
    },
    /**
     * @returns {string} the label for the range end
     */
    rangeEndLabel() {
      if (!this.showLabel) {
        return '';
      }
      if (this.attributeFilter.options._endLabelKey) {
        return this.$t(this.attributeFilter.options._endLabelKey);
      }
      return this.piivoTranslateLabel(this.attributeFilter.options.endLabel);
    },
    /**
     * @returns {*} the value of the range start
     */
    rangeStartValue() {
      if (!this.isDateRange && !this.isNumericRange) {
        return null;
      }
      return Array.isArray(this.value) && this.value.length > 0 ? this.value[0] : null;
    },
    /**
     * @returns {*} the value of the range end
     */
    rangeEndValue() {
      if (!this.isDateRange && !this.isNumericRange) {
        return null;
      }
      return Array.isArray(this.value) && this.value.length > 0 ? this.value[1] : null;
    },
  },
  methods: {
    piivoTranslate(value) {
      return Vue.filter('piivoTranslate')(value);
    },
    piivoTranslateLabel(value) {
      return Vue.filter('piivoTranslateLabel')(value);
    },
    /**
     * @param {object} attribute - the attribute for whom to get the label
     * @returns {string} the label for the attribute
     */
    labelFunction(attribute) {
      if (this.attributeFilter.labelKey) {
        return this.$t(this.attributeFilter.labelKey);
      }
      return this.piivoTranslate(attribute);
    },
    /**
     * Change event for range form
     *
     * @param {String} startValue - start value
     * @param {String} endValue - end value
     * @param {'start'|'end} side - the side of the range that chagned
     */
    onRangeChange(startValue, endValue, side) {
      if (!this.isDateRange && !this.isNumericRange) {
        return;
      }

      let value = [startValue, endValue];

      this.onChange(value);
    },
    /**
     * Emits the changed value
     *
     * @param {*} value - the new value
     */
    onChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>
